import React from 'react'

export const Error = ({children}) => {
    return (
        <div className='py-2 bg-red-100 border border-red-600 rounded px-2 text-red-600 my-2'>
            {children}
        </div>
    )
};


export const Success = ({children}) => {
    return (
        <div className='py-2 bg-green-100 border border-green-600 rounded px-2 text-green-600 my-2'>
            {children}
        </div>
    )
};


